export default (type) => {
    let types = {
        "0": "Наличные",
        "1": "Оплата QR",
        "2": "Переводы",
        "3": "Криптовалюта" 
    }

    return types[String(type)] || "Неизвестный тип"
}